import { render, staticRenderFns } from "./DispoState.vue?vue&type=template&id=8a9c490a&scoped=true&"
import script from "./DispoState.vue?vue&type=script&lang=js&"
export * from "./DispoState.vue?vue&type=script&lang=js&"
import style0 from "./DispoState.vue?vue&type=style&index=0&id=8a9c490a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9c490a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VChip,VIcon,VList,VListItem,VListItemGroup,VMenu})
